import apiService from '../apiService';

const ExpensesService = {
  listExpense: (params) => apiService.get('/expenses', params),
  getExpense: (id) => apiService.get(`/expenses/${id}`),
  createExpense: (data) => apiService.post('/expenses', data),
  updateExpense: (id, data) => apiService.put(`/expenses/${id}`, data),
  deleteExpense: (id) => apiService.delete(`/expenses/${id}`),
};

export default ExpensesService;
